/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Telegram_Mock_New_OrderInputs */

const tr_landing_telegram_mock_new_order = /** @type {(inputs: Landing_Telegram_Mock_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YENİ SİPARİŞ · TRENDYOL`)
};

const en_landing_telegram_mock_new_order = /** @type {(inputs: Landing_Telegram_Mock_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEW ORDER · TRENDYOL`)
};

const de_landing_telegram_mock_new_order = /** @type {(inputs: Landing_Telegram_Mock_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NEUE BESTELLUNG · TRENDYOL`)
};

const ru_landing_telegram_mock_new_order = /** @type {(inputs: Landing_Telegram_Mock_New_OrderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`НОВЫЙ ЗАКАЗ · TRENDYOL`)
};

/**
* | output |
* | --- |
* | "NEW ORDER · TRENDYOL" |
*
* @param {Landing_Telegram_Mock_New_OrderInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_telegram_mock_new_order = /** @type {((inputs?: Landing_Telegram_Mock_New_OrderInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Telegram_Mock_New_OrderInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_telegram_mock_new_order(inputs)
	if (locale === "de") return de_landing_telegram_mock_new_order(inputs)
	if (locale === "ru") return ru_landing_telegram_mock_new_order(inputs)
	return tr_landing_telegram_mock_new_order(inputs)
});